<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="27" height="27" fill="none">
        <circle cx="13.5" cy="13.5" r="12.5" :fill="backgroundColor" :stroke="backgroundColor" stroke-width="2"/>
        <path :fill="checkColor" d="M11.246 14.631S8.73 11.395 6.82 11.9s-1.829 2.149-1.816 2.326c.065.774 1.893 1.917 3.24 3.478 1.48 1.716 2.108 3.328 3.286 3.291 1.18-.036 1.498-.773 1.816-1.752s2.005-4.516 3.218-6.164 4.431-4.812 5.605-5.595c1.016-.674.86-1.01.766-1.247s-.507-.369-1.209-.069c-.7.3-5.57 2.764-7.959 5.39-2.387 2.627-2.516 3.069-2.516 3.069z"/>
    </svg>
</template>

<script setup>

defineProps({
    backgroundColor: {
        type: String,
        default: '#fff'
    },
    checkColor: {
        type: String,
        default: '#577c32'
    }
    // #FA9F42 (orange)
    // #577c32 (gruen)
})
</script>
